// extracted by mini-css-extract-plugin
export default {"root":"ojBr","image":"D3dk","imageIcon":"eSFv"};